import { Outlet } from "react-router-dom"
import { useEffect, useRef, useState, useContext } from 'react'
import { useRefreshMutation } from "./authApiSlice"
import usePersist from "../../hooks/usePersist"
import { useSelector } from 'react-redux'
import { selectCurrentToken } from "./authSlice"
import dataApplicationsContext from '../../context/dataApplicationsContext';
import SyncLoader from "react-spinners/SyncLoader";
import { useLocation } from "react-router-dom";

const PersistLogin = () => {
    const { setIsConnected, setAuth, setIsAppUser } = useContext(dataApplicationsContext);
    const [persist] = usePersist()

    const token = useSelector(selectCurrentToken)
    const effectRan = useRef(false)
    
    const [trueSuccess, setTrueSuccess] = useState(false)
    const location = useLocation()
    
    const [refresh, { isUninitialized, isLoading, isSuccess, isError, error }] = useRefreshMutation()
    
    useEffect(() => {
      if (effectRan.current === true || process.env.NODE_ENV !== 'development') { // React 18 Strict Mode
        const verifyRefreshToken = async () => {
          try {
            const { user, accessToken } = await refresh().unwrap();
            setIsConnected(true);
            setAuth({ user, accessToken });
            setIsAppUser(true);
          } catch (err) {
            console.error(err);
          } finally {
            setTrueSuccess(true);
          }
        };
        
        if (!token && persist) verifyRefreshToken()
      }

      return () => effectRan.current = true
      // eslint-disable-next-line
    }, [])

    let content
    if (!persist) { // persist: no
        // console.log('no persist')
        content = <Outlet />
    } else if (isLoading) { //persist: yes, token: no
        // console.log('loading')
        content = 
            <div className="main-loader-container">
                <div className="main-loader">
                    <img src="/images/logo_cgv.png" alt="Error-404" className="logo-loader"></img>
                    <SyncLoader color='#e1004a' size={16}/>
                </div>
            </div>
    } else if (isError) { //persist: yes, token: no
        // console.log('error : ' + error.data?.message)
        content = <Outlet />
    } else if (isSuccess && trueSuccess) { //persist: yes, token: yes
        // console.log('success')
        content = <Outlet />
    } else if (token && isUninitialized) { //persist: yes, token: yes
        // console.log('token and uninit')
        // console.log(isUninitialized)
        content = <Outlet />
    } else {
        content = 
            <div className="main-loader-container">
                <div className="main-loader">
                    <img src="/images/logo_cgv.png" alt="Error-404" className="logo-loader"></img>
                    <SyncLoader color='#e1004a' size={16}/>
                </div>
            </div>
    }

    return content
}
export default PersistLogin